module.exports = __webpack_public_path__ + "static/media/027-cloud-storage-1.b6fc0947.svg";